import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { TitleBack } from "components/atoms/TitleBack";
import LoyaltyUserInfoContainer from "containers/organisms/LoyaltyUserInfoContainer";
import LoyaltyCarouselContainer from "containers/organisms/LoyaltyCarouselContainer";
import { LoyaltyOnboardingDesktopContainer } from "containers/organisms/LoyaltyOnboardingDesktopContainer";
import LoyaltyRollbackButtonContainer from "containers/atoms/LoyaltyRollbackButtonContainer";
import { LoyaltyBoosterButtonContainer } from "containers/atoms/LoyaltyBoosterButtonContainer";
import LoyaltyContent from "components/atoms/LoyaltyContent";
import { useLoyaltyStore } from "stores/loyalty";
import { useBreakpoint } from "hooks/useBreakpoint";
import { useSplitServiceData } from "queries/useSplitServiceData";
import { makeLangUrl } from "helpers/makeLangUrl";
import { LoyaltyTabs } from "constants/loyalty";
import { LoyaltyContents } from "./constants";
import url from "../../../url";
import { useOffsetTop } from "./hooks";
import "./styles.sass";

const LoyaltyLayout = () => {
  const navigate = useNavigate();
  // const layout = document.querySelector("#profile-layout");
  const { isCustomBreakpointBigger } = useBreakpoint(1180);
  const { loyaltyAccess, isPendingLoyalty } = useSplitServiceData();
  const { loyaltyLocation, setLoyaltyLocation } = useLoyaltyStore((state) => ({
    loyaltyLocation: state.locationLoyalty,
    setLoyaltyLocation: state.setLocationLoyalty,
  }));
  const [isTransparent, setIsTransparent] = useState(true);
  const offsetTop = useOffsetTop();

  useEffect(() => {
    const offset = isCustomBreakpointBigger ? 429 : 350;

    if (offsetTop < offset) {
      setIsTransparent(true);
    } else {
      setIsTransparent(false);
    }
  }, [offsetTop, isCustomBreakpointBigger]);

  useEffect(() => {
    window?.scrollTo({ top: 0, behavior: "smooth" });
  }, [loyaltyLocation]);

  const handleBack = () => {
    navigate(makeLangUrl("/profile"));
  };

  if (!loyaltyAccess && !isPendingLoyalty) {
    return <Navigate to={url.routes.casino.index()} />;
  }

  const contentDesktop = loyaltyLocation === LoyaltyTabs.REWARDS && (
    <LoyaltyUserInfoContainer className="LoyaltyLayout__userInfo" />
  );

  const contentMobile = loyaltyLocation === LoyaltyTabs.REWARDS && (
    <LoyaltyCarouselContainer />
  );

  return (
    <div className="LoyaltyLayout">
      <TitleBack
        onHandleClick={handleBack}
        text="Glory club"
        className="LoyaltyLayout__titleBack"
      />
      {isCustomBreakpointBigger ? contentDesktop : contentMobile}
      {loyaltyLocation === LoyaltyTabs.REWARDS && (
        <div className="LoyaltyLayout__buttons">
          <LoyaltyRollbackButtonContainer />
          <LoyaltyBoosterButtonContainer />
        </div>
      )}
      <LoyaltyContent
        isTransparent={isTransparent}
        activeContent={loyaltyLocation}
        setActiveContent={setLoyaltyLocation}
      >
        {LoyaltyContents[loyaltyLocation]}
      </LoyaltyContent>
      <LoyaltyOnboardingDesktopContainer />
    </div>
  );
};

export default LoyaltyLayout;
